
import Vue from 'vue'
import Router from 'vue-router'
import store from "./store";
import axios from "axios";
Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'login',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Login/login.vue'),
        },
        {
            path: '/signup',
            name: 'signup',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Login/signup.vue'),
        },
        {
            path: '/changePassword',
            name: 'changePassword',
            props: true,
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Login/changePassword.vue'),
        },
        {
            path: '/getOTP',
            name: 'getOTP',
            props: true,
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Login/getOTP.vue'),
        },
        {
            path: '/sellersignup',
            name: 'sellersignup',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Login/sellerSignup.vue'),
        },
        {
            path: '/',
            name: 'home',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/HomePage/home.vue'),
        },
        {
            path: '/products',
            name: 'products',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/ProductPage/products.vue'),
        },
        {
            path: '/productdetail',
            name: 'productdetail',
            // meta: {
            //     requiresAuth: true,
            //     isClient: true,
            //     isSeller: false,
            // },
            component: () =>
                import ('./components/ProductDetail/productsDetail.vue'),
        },
        {
            path: '/myOrder',
            name: 'myOrder',
            props: true,
            meta: {
                requiresAuth:true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/MyOrder/myOrder.vue'),
        },
        {
            path: '/myOrderView',
            name: 'myOrderView',
            props: true,
            meta: {
                requiresAuth:true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/MyOrder/myOrderView.vue'),
        },
        {
            path: '/cart',
            name: 'cart',
            meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Cart/cart.vue'),
        },
        {
            path: '/cartinformation',
            name: 'cartinformation',
            meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Cart/cartInformation.vue'),
        },
        {
            path: '/cartshipping',
            name: 'cartshipping',
            meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Cart/cartShipping.vue'),
        },
        {
            path: '/cartpayment/:id',
            name: 'cartpayment',
            meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
            },
            props: true,
            component: () =>
                import ('./components/Cart/cartPayment.vue'),
        },
        {
            path: '/shippingAddress',
            name: 'shippingAddress',
            meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Profile/shippingAddress.vue'),
        },
        {
            path: '/myprofile',
            name: 'myprofile',
            meta: {
                requiresAuth: true,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Profile/myprofile.vue'),
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/AboutUs/aboutUs.vue'),
        },
        {
            path: '/contactus',
            name: 'contactus',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/ContactUs/contactUs.vue'),
        },
        {
            path: '/beekeepers',
            name: 'beekeepers',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Beekeepers/beeKeepers.vue'),
        },
        {
            path: '/beekeeperProducts/:id',
            name: 'beekeeperProducts',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            props: true,
            component: () =>
                import ('./components/Beekeepers/beekeeperProducts.vue'),
        },
        {
            path: '/blog',
            name: 'blog',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Blog/blog.vue'),
        },
        {
            path: '/blogview',
            name: 'blogview',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Blog/blogView.vue'),
        },
        {
            path: '/map',
            name: 'map',
            meta: {
                requiresAuth: false,
                isClient: true,
                isSeller: false,
            },
            component: () =>
                import ('./components/Map/map.vue'),
        },

        {
            path: '/seller',
            name: 'seller',
            meta: {
                requiresAuth: true,
                isClient: false,
                isSeller: true,
            },
            component: () =>
                import ('./components/Seller/seller.vue'),
            children: [{
                    path: '/addProduct',
                    name: 'addProduct',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/addProduct.vue'),
                },
                {
                    path: '/productSold',
                    name: 'productSold',
                    props: true,
                     meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/productSold.vue'),
                },
                {
                    path: '/analytics',
                    name: 'analytics',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/analytics.vue'),
                },
                {
                    path: '/editSellerprofile',
                    name: 'editSellerprofile',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/editSellerProfile.vue'),
                },
                {
                    path: '/sample',
                    name: 'sample',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: true,
                        isSeller: false,
                    },
                    
                    component: () =>
                        import ('./components/Seller/SellerPortal/sample.vue'),
                },

                {
                    path: '/stock',
                    name: 'stock',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/stock.vue'),
                },
                {
                    path: '/previousOrder',
                    name: 'previousOrder',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/previousOrder.vue'),
                },
                {
                    path: '/productSoldDetails',
                    name: 'productSoldDetails',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/productSoldDetails.vue'),
                },
                {
                    path: '/sellerprofile',
                    name: 'sellerprofile',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/sellerProfile.vue'),
                },
                {
                    path: '/topSelling',
                    name: 'topSelling',
                    props: true,
                    meta: {
                        requiresAuth: true,
                        isClient: false,
                        isSeller: true,
                    },
                    component: () =>
                        import ('./components/Seller/SellerPortal/topSelling.vue'),
                },
            ]
        },
        {
            path: '/ServerError',
            name: 'ServerError',
            props: true,
            component: () =>
                import ('./components/Common/500.vue'),
        },

        {
            path: '*',
            name: '404PageNotFound',
            props: true,
            component: () =>
                import ('./components/Common/404.vue'),
        },


    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },
})


router.beforeEach((to, from, next) => {
    if (
        to.matched.some((route) => route.name == "login") &&
        store.state.isLoggedIn
    ) {
        next({ name: "home" });
        return;
    }
    if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
        axios({
                method: 'POST',
                url: '/validate/token',
                headers: {
                    'x-auth-token': localStorage.getItem('token')
                }
            }).then(response => {
                if (!response.data.status) {
                    store.commit("sessionOut", true)
                    return
                }
            })
            .catch(err => {
                this.msg = err;
            });
    }
    if ((to.name == 'login') && store.state.isLoggedIn == true) {
        next({ name: 'home' })
        return
    }
    next()
        // if (
        //     to.matched.some((route) => route.meta.requiresAuth) &&
        //     !store.state.isLoggedIn
        // ) {
        //     next({ name: "login", query: { lastPage: from.fullPath } });
        //     return;
        // }
        // if (store.state.isLoggedIn == true) {
        //   axios({
        //     method: "POST",
        //     url: "/validate/token",
        //     headers: {
        //       token: localStorage.getItem("token"),
        //     },
        //   })
        //     .then((response) => {
        //       if (!response.data.status) {
        //         store.commit("sessionOut", true);
        //         return;
        //       }
        //     })
        //     .catch((err) => {
        //       var msg = err;
        //       console.log(msg);
        //     });
        // }
        if (to.matched.some(route => route.meta.requiresAuth == true) && store.state.isLoggedIn == false) {
           
            next({ name: 'login' })
            return
        }
        if (to.matched.some(route => route.meta.isSeller == false) && store.state.isLoggedIn == true && (store.state.userRole == 'User')) {
            next({ name: 'sellerprofile' })
            return
        }
        if (to.matched.some(route => route.meta.isClient == false) && store.state.isLoggedIn == true && (store.state.userRole == 'Customer')) {
            next({ name: 'home' })
            return
        }


    next();
});


export default router